import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var AttachmentSVG = function AttachmentSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 29.5a7 7 0 01-7-7v-12a1 1 0 012 0v12a5 5 0 0010 0v-15a3 3 0 00-6 0v12a1 1 0 002 0v-9a1 1 0 012 0v9a3 3 0 01-6 0v-12a5 5 0 0110 0v15a7 7 0 01-7 7z"
  }));
};
AttachmentSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AttachmentSVG);